<div
  class="tw-max-w-72 tw-rounded-2xl tw-bg-white tw-p-6 tw-shadow-xl md:tw-max-w-md lg:tw-max-w-xl"
  role="dialog"
  aria-labelledby="clone-dialog-title"
  aria-describedby="clone-dialog-body"
>
  <!-- Header -->
  <h4
    class="tw-mb-4 tw-font-extrabold tw-text-neutral-900"
    id="clone-dialog-title"
  >
    {{ i18n.Automation_CloneAutomation }}
  </h4>

  <!-- Body -->
  <div class="tw-mb-6 tw-text-neutral-900" id="clone-dialog-body">
    {{ bodyText }}
  </div>

  <!-- Footer -->
  <div class="tw-flex tw-justify-end tw-gap-4">
    <button
      type="button"
      (click)="close()"
      class="tw-btn-secondary-outline tw-btn-medium"
      data-dgat="automation-clone-modal-cancel-btn"
    >
      {{ i18n.Core_Cancel }}
    </button>
    <button
      type="button"
      (click)="!isSaving && onSubmit()"
      [attr.aria-disabled]="isSaving"
      [attr.aria-label]="isSaving ? i18n.Core_Loading : i18n.Core_Confirm"
      class="tw-btn-primary tw-btn-medium"
      [class.tw-opacity-60]="isSaving"
      [class.tw-cursor-not-allowed]="isSaving"
      data-dgat="automation-clone-modal-confirm-btn"
    >
      @if (isSaving) {
        <da-icon icon="arrow-path" type="solid-small" class="tw-animate-spin" />
      }
      {{ i18n.Core_Confirm }}
    </button>
  </div>
</div>
